/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LogProbToken = {
  token: string;
  logprob: number;
  bytes?: Array<number> | undefined;
};

/** @internal */
export const LogProbToken$inboundSchema: z.ZodType<
  LogProbToken,
  z.ZodTypeDef,
  unknown
> = z.object({
  token: z.string(),
  logprob: z.number(),
  bytes: z.array(z.number()).optional(),
});
/** @internal */
export type LogProbToken$Outbound = {
  token: string;
  logprob: number;
  bytes?: Array<number> | undefined;
};

/** @internal */
export const LogProbToken$outboundSchema: z.ZodType<
  LogProbToken$Outbound,
  z.ZodTypeDef,
  LogProbToken
> = z.object({
  token: z.string(),
  logprob: z.number(),
  bytes: z.array(z.number()).optional(),
});

export function logProbTokenToJSON(logProbToken: LogProbToken): string {
  return JSON.stringify(LogProbToken$outboundSchema.parse(logProbToken));
}
export function logProbTokenFromJSON(
  jsonString: string,
): SafeParseResult<LogProbToken, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LogProbToken$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LogProbToken' from JSON`,
  );
}
